import imageCompression from 'browser-image-compression';

document.addEventListener('turbo:load', function () {
  document.querySelectorAll('.multiple-image-field').forEach(function (input) {
    input.addEventListener('change', async function (event) {
      const files = event.target.files;
      if (!files || files.length === 0) return;

      const filesArray = Array.from(files);
      const compressedFiles = [];
      const options = {
        maxSizeMB: 10,
        maxWidthOrHeight: 1024,
        useWebWorker: true,
      };

      const submitButton = document.querySelector('input[type="submit"], button[type="submit"]');
      if (submitButton) submitButton.disabled = true;

      for (const file of filesArray) {
        try {
          const compressedBlob = await imageCompression(file, options);
          compressedFiles.push(new File([compressedBlob], file.name, { type: file.type || 'image/jpeg' }));
        } catch (error) {
          console.warn('Image compression failed for', file.name, error);
          compressedFiles.push(file);
        }
      }

      if (compressedFiles.length === 0) {
        if (submitButton) submitButton.disabled = false;
        return;
      }

      const dataTransfer = new DataTransfer();
      compressedFiles.forEach(function (file) {
        dataTransfer.items.add(file);
      });

      event.target.files = dataTransfer.files;

      if (submitButton) submitButton.disabled = false;
    });
  });
});